import React, { useState, useEffect } from 'react';
import {
  SidebarQuarterlyContainer,
  AccordionTitle,
  AccordionContent,
  AccordionContentFuture,
  AccordionText,
  OrangeColorStyle,
  RowStyle,
  LegendTextStyle,
  QuarterHeaderTitle,
} from '../../../atoms/sidebar/sidebar.styles';
import Legend from './legend';
import MontlySideBar from './montlySideBar';
import flagOutline from '../../../assets/icons/flagOutline.png';
import flagImage from '../../../assets/icons/flag-alt.png';
import { CrmChartQuarterly } from './crmChartQuarterly';
import { formatNumberWithKAndM } from '../../../../util/commonUtil';
import {
  FORECAST_SIDEBAR_QUARTER_CONST,
  QUARTERLY_DETAILS,
} from '../../../../constants/commonConstants';

function QuarterlyExpandedSidebar(props) {
  let data = props?.data;
  let quarter = props?.quarter;
  let year = props?.year;
  let quarterTitle = props?.quarterTitle;
  let expanded = props?.expanded;
  let toggleAccordion = props?.toggleAccordion;

  let propsData = {};

  const [noCommitValue, setNoCommitValue] = useState(data['quarterlyCalculation']?.noCommit || 0);

  useEffect(() => {
    setNoCommitValue(data['quarterlyCalculation']?.noCommit || 0);
  }, [data]);


  const handleKeyPress = event => {
    if (event.code === 'Enter') {
      toggleAccordion();
    }
  };

  const addFocus = event => {
    event.target.classList.add('focusContainer');
  };

  const removeFocus = event => {
    event.target.classList.remove('focusContainer');
  };

  return (
    <>

      <SidebarQuarterlyContainer
        className={expanded ? 'expanded' : 'expanded'}
        onKeyDown={handleKeyPress}
        onFocus={addFocus}
        onBlur={removeFocus}
      >
        <AccordionTitle onClick={toggleAccordion}>
          <QuarterHeaderTitle>{quarterTitle}</QuarterHeaderTitle>
          {(quarterTitle == FORECAST_SIDEBAR_QUARTER_CONST.NOW ||
            quarterTitle == FORECAST_SIDEBAR_QUARTER_CONST.NEXT) && (
            <QuarterHeaderTitle>
              {quarter} | FY {year}
            </QuarterHeaderTitle>
          )}

          {quarterTitle == FORECAST_SIDEBAR_QUARTER_CONST.BEYOND && (
            <QuarterHeaderTitle>
              All after {quarter} | FY {year}
            </QuarterHeaderTitle>
          )}
        </AccordionTitle>

        {quarterTitle == FORECAST_SIDEBAR_QUARTER_CONST.NOW && (
          <AccordionContent>
            <CrmChartQuarterly quarterlyData={data['quarterlyCalculation']} />
            <Legend
              quarterlyData={data['quarterlyCalculation']}
              quarterText={quarter}
              flagImageSrc={flagImage}
            />
            <AccordionText style={{ color: '#ffffff' }}>
              {QUARTERLY_DETAILS.NO_COMMIT}: {formatNumberWithKAndM(noCommitValue)}
            </AccordionText>
          </AccordionContent>
        )}

        {quarterTitle == FORECAST_SIDEBAR_QUARTER_CONST.NEXT && (
          <AccordionContentFuture>
            <img src={flagOutline} alt=" " />
            <span>{formatNumberWithKAndM(data['quarterlyCalculation']?.commit) || 0}</span>
            <RowStyle>
              <OrangeColorStyle />
              <LegendTextStyle>Projected</LegendTextStyle>
            </RowStyle>
            <AccordionText style={{ color: '#ffffff' }}>
              {QUARTERLY_DETAILS.NO_COMMIT} : {formatNumberWithKAndM(noCommitValue)}
            </AccordionText>
          </AccordionContentFuture>
        )}

        {!!data && <MontlySideBar quarterData={data} propsData={propsData} />}
      </SidebarQuarterlyContainer>
    </>
  );
}

export default QuarterlyExpandedSidebar;
